import { IAppFrom } from "../interfaces/IAppFrom";
export const getWebUrl = (from, appId) => {
    const baseUrl = window.location.origin;
    switch (from) {
        case IAppFrom.CONTACT:
            return encodeURIComponent(`${baseUrl}/contact/${appId ?? ""}`);
        case IAppFrom.KEEPASS:
            return encodeURIComponent(`${baseUrl}/keepass`);
        case IAppFrom.MAP:
            return encodeURIComponent(`${baseUrl}/map/${appId ?? ""}`);
        case IAppFrom.BOOKING:
        case IAppFrom.CALENDAR:
        case IAppFrom.SHAREDCALENDAR:
        case IAppFrom.PARKING:
            return encodeURI(`${baseUrl}/calendars/${appId ?? ""}`);
        case IAppFrom.GANTT:
            return encodeURIComponent(`${baseUrl}/gantt`);
        default:
            return encodeURIComponent(`${baseUrl}`);
    }
};
